import { render } from "./Step4Block.vue?vue&type=template&id=78c81e4a"
import script from "./Step4Block.vue?vue&type=script&lang=js"
export * from "./Step4Block.vue?vue&type=script&lang=js"

import "./Step4Block.vue?vue&type=style&index=0&id=78c81e4a&lang=sass"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__